import { useLocalSearchParams, usePathname } from 'expo-router';

import { IRouteHook } from '../types';

/** @deprecated use usePathname() or use[Local/Global]SearchParams instead */
export const useRoute = <T extends object>(): IRouteHook<T> => {
  const pathname = usePathname();
  const params = useLocalSearchParams();

  return {
    params: params as T,
    pathname,
  };
};
